import { useEffect } from 'react';

// Fading paw prints trailing the cursor (desktop pointers only).
export const CursorTrail = () => {
  useEffect(() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return undefined;
    let last = 0;
    let side = 1;
    const onMove = (e) => {
      const now = performance.now();
      if (now - last < 80) return;
      last = now;
      side = -side;
      const el = document.createElement('div');
      el.className = 'paw-trail';
      el.style.left = `${e.clientX + side * 9}px`;
      el.style.top = `${e.clientY + 12}px`;
      el.style.setProperty('--rot', `${side * 20}deg`);
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 950);
    };
    const onDown = (e) => {
      const burst = (dx, dy, delay) => {
        const el = document.createElement('div');
        el.className = 'paw-scratch';
        el.style.left = `${e.clientX + dx - 12}px`;
        el.style.top = `${e.clientY + dy - 12}px`;
        el.style.animationDelay = `${delay}ms`;
        document.body.appendChild(el);
        setTimeout(() => el.remove(), 1000);
      };
      burst(0, 0, 0);
      burst(-16, 8, 90);
      burst(14, 10, 180);
    };
    window.addEventListener('mousemove', onMove, { passive: true });
    window.addEventListener('mousedown', onDown, { passive: true });
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mousedown', onDown);
    };
  }, []);
  return null;
};
